import React, { lazy } from 'react';
import { PaymentMethods } from './PaymentMethods';
export function Footer() {
  return <footer className="bg-cream py-12 border-t border-ink/5" data-id="element-360">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center" data-id="element-361">
        <img src="https://cdn.magicpatterns.com/uploads/jM8x4CKNU9ZJMg3W1QhsX7/ChatGPT_Image_20_may_2026,_11_40_53_p.m..png" alt="Recetas PowerFit · Recetas saludables para tu mejor versión" className="w-40 h-40 sm:w-48 sm:h-48 object-contain" loading="lazy" data-id="element-362" />
        <PaymentMethods className="mt-6" data-id="element-363" />
      </div>
    </footer>;
}